import { render } from "./LandingMatchShowcase.vue?vue&type=template&id=12949c71&scoped=true"
import script from "./LandingMatchShowcase.vue?vue&type=script&lang=js"
export * from "./LandingMatchShowcase.vue?vue&type=script&lang=js"

import "./LandingMatchShowcase.vue?vue&type=style&index=0&id=12949c71&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12949c71"]])

export default __exports__